module.exports = __webpack_public_path__ + "e7372dd6e1202ea5d411b58fbcd3b908.png";